/* tslint:disable:no-any only-arrow-functions */
// tslint:disable-next-line: no-import-side-effect
import './Scss/App.scss';

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App from '@app/App';
import { appStore } from './Stores/AppStore';

const keydownHandler = (event: KeyboardEvent) => {
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey); // event.metaKey - On Macintosh keyboards, this is the ⌘ Command key
    appStore.isShiftKey = event.shiftKey;
    return true;
};

const keyupHandler = (event: KeyboardEvent) => {
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey); // event.metaKey - On Macintosh keyboards, this is the ⌘ Command key
    appStore.isShiftKey = event.shiftKey;
    return true;
};

let devicePixelRatio: number = 0;
const resizeHandler = () => {
    if (!devicePixelRatio || devicePixelRatio !== window.devicePixelRatio) {
        devicePixelRatio = window.devicePixelRatio;
        let scrollBarWidth = 17;
        if (devicePixelRatio < 1) {
            scrollBarWidth = (2 - devicePixelRatio) * scrollBarWidth;
        } else {
            scrollBarWidth = scrollBarWidth / devicePixelRatio;
        }
        document.body.style.setProperty('--scrollbar-width', scrollBarWidth + 'px');
    }
};

document.addEventListener('keydown', keydownHandler, true);
document.addEventListener('keyup', keyupHandler, true);
window.addEventListener('resize', resizeHandler);

const rootEl = document.getElementById('react-app') as HTMLElement;

type IWindowWithAuth = Window & {
    isAuthReady?: boolean;
};

const renderApp = () => ReactDOMClient.createRoot(rootEl).render(<App callback={resizeHandler} />);

// In refresh-token mode adal.js exchanges the authorization code asynchronously, so there may be no token yet
// when this bundle runs; mounting early would make every initial request 401. The legacy implicit flow finishes
// synchronously and has already set isAuthReady by this point.
if ((window as IWindowWithAuth).isAuthReady) {
    renderApp();
} else {
    document.addEventListener('auth-ready', renderApp);
}
